import {Stack, styled} from '@mui/material';

export const LocationWrapper = styled(Stack)`
	padding: 32px;
	width: 100%;
	gap: 16px;
	max-width: ${({theme}) => theme.breakpoints.values.md};

	${({theme}) => theme.breakpoints.down('sm')} {
		padding: 16px 16px 72px;
	}
`;
